export default "__VITE_PUBLIC_ASSET__d5f6b5d1__"